import { FormGroup } from '@angular/forms';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const getScopoSocialeGroup = (form: FormGroup): FormGroup =>
    getGroup(form, formPaths.scopoSociale);

export const getScopoSocialeControl = (form: FormGroup, path: string) =>
    getControl(form, `${formPaths.scopoSociale}.${path}`);
